import React, { Component } from 'react'
import '../styles/CalendarView.css'

class MonthSelector extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			value: props.placeholder,
			year: props.placeholder.split(" ")[1],
			list: (props.list === null)? []: props.list,
			items: [],
			onItemSelected: props.onItemSelected,
			cStyle: props.cStyle
		}
		this.content = React.createRef()
		this.button = React.createRef()
		this.setItems = this.setItems.bind(this)
	}

	componentWillMount() {
		this.setItems(this.state.year)
	}

	setItems(year) {
		if(this.props.list != null) {
			const items = []
			for(const v of this.props.list) {
				items.push(<a href="#" id={v.id} onClick={(e) => {
					this.onItemSelected(e.target.id, e.target.innerHTML)
				}}>{v.name}</a>)
			}
			items.push(<a href="#" id={-1} onClick={(e) => {
				this.onItemSelected(e.target.id, e.target.innerHTML)
			}}>{"<<"}</a>)
			items.push(<div><label>{year}</label></div>)
			items.push(<a href="#" id={-2} onClick={(e) => {
				this.onItemSelected(e.target.id, e.target.innerHTML)
			}}>{">>"}</a>)
			this.setState({items: items, year: year})
		}
	}

	onItemSelected(id, val) {
		if(id == -1) {
			this.setItems(--this.state.year)
			return
		}
		else if(id == -2) {
			this.setItems(++this.state.year)
			return
		}
		this.setState({value: val + " " + this.state.year})
		if(this.state.onItemSelected != null) {
			this.state.onItemSelected(id, val, this.state.year)
		}
		this.content.current.className = 'ms-menu-items'
	}

	componentDidUpdate(prevProps) {
		if(this.props.list != prevProps.list) {
			const items = []
			for(const v of this.props.list) {
				items.push(<a href="#" id={v.id} onClick={(e) => {
					this.onItemSelected(e.target.id, e.target.innerHTML)
				}}>{v.name}</a>)
			}
			this.setState({items: items})
		}
		if(this.props.placeholder != prevProps.placeholder) {
			this.setState({value: this.props.placeholder})
		}
		if(this.props.year != prevProps.year) {
			this.setItems(this.props.year)
		}
	}

	render() {
		if(this.props.disabled && this.content.current != null) {
			this.content.current.className = 'ms-menu-items'
		}
		return(<div className="month-selector" style={this.state.cStyle}
			onMouseLeave={() => { this.content.current.className = 'ms-menu-items' }}>
			<button id="chb-month" ref={this.button} disabled={this.props.disabled}
				onClick={() => {
					this.content.current.className = 'ms-content'
				}}>{this.state.value}</button>
			<div className="ms-menu-items" ref={this.content} onMouseLeave={() => {this.content.current.className = 'ms-menu-items'}}>{this.state.items}</div>
		</div>)
	}
}

export default MonthSelector
